import baSys from "@/assets/img/apps/baSys.svg";
import bCollection from "@/assets/img/apps/bCollection.svg";
import bDrive from "@/assets/img/apps/bDrive.svg";
import toolbox from "@/assets/img/apps/toolbox.svg";
import tyreLink from "@/assets/img/apps/tyreLink.svg";

export const portalAppLogoByCodeName = {
  baSys,
  bCollection,
  bDrive,
  toolbox,
  tyreLink,
};

export function getPortalAppLogoSrc(codeName) {
  if (!codeName) return null;
  return portalAppLogoByCodeName[codeName] ?? null;
}
